import React from 'react';
import { Modal, Upload, Button, Col, Row, Icon } from 'antd';
import { compose } from 'redux';
import { firebaseConnect } from 'react-redux-firebase'
import { translate } from 'react-i18next';
import camera from '../../images/camera.png'
import profileImage from '../../images/profileImage.png'
import { withRouter } from 'react-router'

class StudentProfile extends React.Component {

  state= {
    selectedAvatar: 'none',
    selectedTone: 'none',
    toneSelect: false,
    imageSelect: false,
    previewImg: "",
    imageMode: null,
    uploadData: "",
    editingField: null
  }

  previewImage = (props) => {
    let reader = new FileReader();
    const _this = this
    reader.onload = function(e) {
      _this.setState({previewImg: e.target.result});
    }
    reader.readAsDataURL(props.file);
    this.setState({selectedAvatar: 'none', selectedTone: 'none', uploadData: props.file, imageMode: 'upload'})
  }

  saveAvatar = async () => {
    const { uid } = this.props
    const user = this.props.firebase.auth().currentUser;
    const storageRef = this.props.firebase.storage().ref();
    const ref = storageRef.child(`/avatars/${avatars[this.state.selectedAvatar][this.state.selectedTone].name}`);
    const url = await ref.getDownloadURL()
    await this.props.firebase.database().ref(`users/${uid}/profile`).update({
      image: url
    })
    return url;
  }

  removePhoto = () => {
      const user = this.props.firebase.auth().currentUser;
      return user.updateProfile({ photoURL: null})
  }

  uploadImage = () => {
    let uid = this.props.uid
    let imagesUrl;
    return this.props.firebase.uploadFile(`profile-images/${uid}`, this.state.uploadData)
      .then( (snapshot) => {
          imagesUrl = snapshot.uploadTaskSnaphot.metadata.downloadURLs[0]
          const user = this.props.firebase.auth().currentUser;
          return user.updateProfile({ photoURL: imagesUrl})
      })
  }

  onDone = () => {
    this.setState({imageSelect: false})
    if (this.state.imageMode == 'remove') {
      this.removePhoto()
    } else if (this.state.selectedAvatar !== 'none' && this.state.selectedTone !== 'none') {
      this.saveAvatar()
    } else {
      this.uploadImage()
    }
  }

  imagePreview = () => {
    if (this.state.imageMode == 'remove') {
      return profileImage
    } else if (this.state.selectedAvatar !== 'none' && this.state.selectedTone !== 'none') {
      return  avatars[this.state.selectedAvatar][this.state.selectedTone].src
    } else if (this.state.previewImg) {
      return this.state.previewImg
    } else {
      return this.props.image
    }
  }

  logout = () => {
    this.props.firebase.logout();
    this.props.history.push("/")
  }

  changeProfile = (field, value) => {
    const { firebase, uid } = this.props
    this.setState({editing: false})
    firebase.database().ref(`/users/${uid}/profile`).update({
      [field]: value
    })
  }

  render() {

    const { color, product } = this.props

    const styles = {
      modal: {
        position: 'absolute',
        right: 0,
        top: 0,
        minHeight: '100vh',
        height: '100%'
      },
      imageDiv: {
        height: 140,
        width: 140,
        overflow: 'hidden',
        borderRadius: '50%',
        margin: '0 auto',
        boxShadow: '1px 3px 9px 1px #888888'
      },
      title: {
        fontFamily: 'Arial Rounded MT Bold',
        color: color,
        fontSize: 14,
        marginTop: 30
      },
      info: {
        fontFamily: 'Arial Rounded MT Bold',
        color: color,
        fontSize: 14,
        width: '100%',
        borderBottom: `1px solid ${color}`,
        paddingBottom: 3
      },
      imageSelect: {
        position: 'absolute',
        right: 349,
        height: '100%',
        top: 0,
        backgroundColor: 'white',
        width: 400,
        zIndex: '-1',
        backgroundColor: '#F1F1F1',
        transition: 'right 1s'
      },
      button: {
        backgroundColor: color,
        color: 'white',
        border: 'none',
        borderRadius: '20px',
        width: 180
      },
      logout: {
        backgroundColor: color,
        color: 'white',
        border: 'none',
        borderRadius: '20px',
        width: 120,
        display: 'block',
        margin: '0 auto',
        marginTop: 40
      },
      avatar: {
        width: '100%',
        height: 'auto'
      },
      avatarSelect: {
        width: 300,
        position: 'absolute',
        bottom: 100,
        border: '2px solid white',
        borderRadius: 10,
        backgroundColor: '#EFEFEF',
        zIndex: 1,
        boxShadow: '3px 6px 8px #888888'
      },
      rectangle: {
      	width: 0,
      	height: 0,
      	borderBottom: '10px solid #D3D2D3',
      	borderLeft: '10px solid transparent',
        position: 'absolute',
        right: 0,
        bottom: 0
      },
      cameraDiv: {
        width: 40,
        position: 'absolute',
        right: 0,
        bottom: 0,
        borderRadius: '50%',
        backgroundColor: color,
        border: '1px solid white',
        padding: 7,
        cursor: 'pointer'
      },
      doneBtn: {
        textAlign: 'center',
        position: 'absolute',
        bottom: 0,
        width: '100%',
        backgroundColor: color,
        color: 'white',
        fontSize: 17,
        padding: '10px 0px',
        cursor: 'pointer'
      },
      lang: {
        color: '#2A6385',
        fontSize: 23,
        fontWeight: 'bold',
        cursor: 'pointer',
        width: 'fit-content',
        marginRight: 29,
        float: 'left'
      },
      langDisabled: {
        color: '#bfbfbf',
        fontSize: 23,
        cursor: 'disabled',
        width: 'fit-content',
        marginRight: 29,
        float: 'left'
      }
    }
    const { t, lng } = this.props
    return (
      <Modal
        visible={this.props.open}
        onCancel={this.props.close}
        footer={null}
        style={styles.modal}
        width={350}
        bodyStyle={{height: '100vh', height: 980}}
        wrapClassName='studentProfile'
      >
        <div style={{position: 'relative', width: 140, margin: '0 auto'}}>
          <div style={styles.imageDiv}>
            <img style={{width: '100%', height: 'auto'}} src={this.props.image} />
          </div>
          <div onClick={() => this.setState({imageSelect: true})} style={styles.cameraDiv}><img src={camera} style={styles.avatar} /></div>
        </div>
        {product == 'Skill' &&
        <div>
          <h3 className='noAvenir' style={styles.title}>{t('Language')}</h3>
          <div style={{display: 'inline-block', height: 20, width: '100%'}}>
            <p onClick={() => this.props.changeLanguage('EN')} style={lng == 'EN' ? styles.langDisabled : styles.lang}>EN</p>
            <p onClick={() => this.props.changeLanguage('FR')} style={lng == 'FR' ? styles.langDisabled : styles.lang}>FR</p>
          </div>
        </div>
        }
        {product == 'Service' &&
          <div>
            <h3 className='noAvenir' style={styles.title}>{t('Theme')}</h3>
            <div style={{display: 'inline-flex', width: '100%', marginTop: 5}}>
              <span onClick={() => this.props.changeTheme('default')} style={{width: 25, height: 25, borderRadius: '50%', backgroundColor: '#006588', marginRight: 40, cursor: 'pointer'}}></span>
              <span onClick={() => this.props.changeTheme('pink')} style={{width: 25, height: 25, borderRadius: '50%', backgroundColor: '#FF6CA3', marginRight: 40, cursor: 'pointer'}}></span>
              <span onClick={() => this.props.changeTheme('gray')} style={{width: 25, height: 25, borderRadius: '50%', backgroundColor: '#7c868d', marginRight: 40, cursor: 'pointer'}}></span>
            </div>
          </div>
        }
        <h3 className='noAvenir' style={styles.title}>{t('Name')}</h3>
        <p className='noAvenir' style={styles.info}>{`${this.props.data.name} ${this.props.data.last_name}`}</p>
        <h3 className='noAvenir' style={styles.title}>{t('Email')}</h3>
        <p className='noAvenir' style={styles.info}>{this.props.data.email}</p>
        <h3 className='noAvenir' style={styles.title}>{t('Grade')}</h3>
        <p className='noAvenir' style={styles.info}>{this.props.data.myp}</p>
        <h3 className='noAvenir' style={styles.title}>{t('School')}</h3>
        <p className='noAvenir' style={styles.info}>{this.props.data.school && this.props.data.school.name}</p>
        {product == 'Skill' &&
          <div>
            <h3 className='noAvenir' style={styles.title}>{t('Theme')}</h3>
            <div style={{display: 'inline-flex', width: '100%', marginTop: 5}}>
              <span onClick={() => this.props.changeTheme('default')} style={{width: 25, height: 25, borderRadius: '50%', backgroundColor: '#006588', marginRight: 40, cursor: 'pointer'}}></span>
              <span onClick={() => this.props.changeTheme('pink')} style={{width: 25, height: 25, borderRadius: '50%', backgroundColor: '#FF6CA3', marginRight: 40, cursor: 'pointer'}}></span>
              <span onClick={() => this.props.changeTheme('gray')} style={{width: 25, height: 25, borderRadius: '50%', backgroundColor: '#7c868d', marginRight: 40, cursor: 'pointer'}}></span>
            </div>
          </div>
        }
        {product == 'Service' &&
          <div>

            <div style={{ display: 'inline-flex', alignItems: 'center', justifyContent: 'space-between', width: '100%' }}>
              <h3 className='noAvenir' style={styles.title}>{t('Interests')}</h3>
              <Icon
                style={styles.title}
                type='edit'
                onClick={() => this.setState({ editing: 'interests' },
                  () => this.interestsInput.focus())}
              />
            </div>
            {this.state.editing == 'interests'
              ? <input
                defaultValue={this.props.data.interests}
                style={styles.input}
                ref={(input) => { this.interestsInput = input; }}
                onBlur={(e) => this.changeProfile('interests', e.target.value)}
              />
              : <p className='noAvenir' style={styles.info}>{this.props.data.interests}</p>
            }

            <div style={{display: 'inline-flex', alignItems: 'center', justifyContent: 'space-between', width: '100%'}}>
              <h3 className='noAvenir' style={styles.title}>{t('Skills')}</h3>
              <Icon
                style={styles.title}
                type='edit'
                onClick={() => this.setState({editing: 'skills'},
                  () => this.skillsInput.focus())}
              />
            </div>
          {this.state.editing == 'skills'
              ? <input
                  defaultValue={this.props.data.skills}
                  style={styles.input}
                  ref={(input) => { this.skillsInput = input; }}
                  onBlur={(e) => this.changeProfile('Skills', e.target.value)}
                />
              : <p className='noAvenir' style={styles.info}>{this.props.data.Skills}</p>
            }

            <div style={{display: 'inline-flex', alignItems: 'center', justifyContent: 'space-between', width: '100%'}}>
              <h3 className='noAvenir' style={styles.title}>{t('Talents')}</h3>
              <Icon
                style={styles.title}
                type='edit'
                onClick={() => this.setState({editing: 'talents'},
                  () => this.talentsInput.focus())}
              />
            </div>
            {this.state.editing == 'talents'
              ? <input
                  defaultValue={this.props.data.talents}
                  style={styles.input}
                  ref={(input) => { this.talentsInput = input; }}
                  onBlur={(e) => this.changeProfile('talents', e.target.value)}
                />
              : <p className='noAvenir' style={styles.info}>{this.props.data.talents}</p>
            }


          </div>
        }
        <Button style={styles.logout} onClick={() => this.logout()}>{t('Log out')}</Button>




        {/*Sider */}
        <div style={styles.imageSelect} className={!this.state.imageSelect && 'imageSelect-closed'}>
          <span className="ant-modal-close-x" style={{position: 'absolute', right: 10, cursor: 'pointer' }} onClick={() => this.setState({imageSelect: false})}></span>
          <div style={{backgroundColor: 'white', padding: '30px 0px'}}>
            <div style={styles.imageDiv}>
              <img style={{width: '100%', height: 'auto'}}
                    src={this.imagePreview()}
                />
            </div>
          </div>
          <div style={{display: 'inline-flex', justifyContent: 'space-evenly', width: '100%', backgroundColor: 'white', backgroundColor: 'white', paddingBottom: 20}}>
            <Upload customRequest={this.previewImage} showUploadList={false} accept="image/*" multiple={false}>
              <Button style={styles.button}>{t('Upload Photo')}</Button>
            </Upload>
          <Button onClick={() => this.setState({imageMode: 'remove'})} style={styles.button}>{t('Remove Photo')}</Button>
          </div>
            <Row>
            {avatars.map( (avatar, index) => (
              <Col style={{height: 100}} span={6}>
                <img style={styles.avatar} src={avatar[0].src} onClick={() => this.setState({selectedAvatar: index, toneSelect: true})}/>
                <span style={styles.rectangle}></span>
                {index == this.state.selectedAvatar && this.state.toneSelect &&
                  <div className={(index+1)%4 == 0  || (index+2)%4 == 0 ? 'rightAlign' : 'leftAlign'} style={styles.avatarSelect}>
                    {avatars[this.state.selectedAvatar].map( (item, index) =>
                      <Col onClick={() => this.setState({selectedTone: index, toneSelect: false, previewImg: "", imageMode: 'upload'})} span={8}><img style={styles.avatar} src={item.src} /></Col>
                    )}
                  </div>
                }
              </Col>
            ))}
            </Row>
          <div>
          </div>
          <div onClick={() => this.onDone()} style={styles.doneBtn}>{t('Done')}</div>
        </div>
      </Modal>
    )
  }
}

const enhancer = compose(
  translate('lang'),
  firebaseConnect()
)
export default withRouter(enhancer(StudentProfile))

const avatars = [
  [
    {src: require("../../images/Avatar/Asset 1@3x.png"), name:'av1-1.png'},
    {src: require("../../images/Avatar/Asset 1.1@3x.png"), name: 'av1-2.png'},
    {src: require("../../images/Avatar/Asset 1.2@3x.png"), name: 'av1-3.png'},
  ],
  [
    {src: require("../../images/Avatar/Asset 2@3x.png"), name:'av2-1.png'},
    {src: require("../../images/Avatar/Asset 2.1@3x.png"), name: 'av2-2.png'},
    {src: require("../../images/Avatar/Asset 2.2@3x.png"), name: 'av2-3.png'},
  ],
  [
    {src: require("../../images/Avatar/Asset 3@3x.png"), name:'av3-1.png'},
    {src: require("../../images/Avatar/Asset 3.1@3x.png"), name: 'av3-2.png'},
    {src: require("../../images/Avatar/Asset 3.2@3x.png"), name: 'av3-3.png'},
  ],
  [
    {src: require("../../images/Avatar/Asset 4@3x.png"), name:'av4-1.png'},
    {src: require("../../images/Avatar/Asset 4.1@3x.png"), name: 'av4-2.png'},
    {src: require("../../images/Avatar/Asset 4.2@3x.png"), name: 'av4-3.png'},
  ],
  [
    {src: require("../../images/Avatar/Asset 5@3x.png"), name:'av5-1.png'},
    {src: require("../../images/Avatar/Asset 5.1@3x.png"), name: 'av5-2.png'},
    {src: require("../../images/Avatar/Asset 5.2@3x.png"), name: 'av5-3.png'},
  ],
  [
    {src: require("../../images/Avatar/Asset 6@3x.png"), name:'av6-1.png'},
    {src: require("../../images/Avatar/Asset 6.1@3x.png"), name: 'av6-2.png'},
    {src: require("../../images/Avatar/Asset 6.2@3x.png"), name: 'av6-3.png'},
  ],
  [
    {src: require("../../images/Avatar/Asset 7@3x.png"), name:'av7-1.png'},
    {src: require("../../images/Avatar/Asset 7.1@3x.png"), name: 'av7-2.png'},
    {src: require("../../images/Avatar/Asset 7.2@3x.png"), name: 'av7-3.png'},
  ],
  [
    {src: require("../../images/Avatar/Asset 8@3x.png"), name:'av8-1.png'},
    {src: require("../../images/Avatar/Asset 8.1@3x.png"), name: 'av8-2.png'},
    {src: require("../../images/Avatar/Asset 8.2@3x.png"), name: 'av8-3.png'},
  ],
  [
    {src: require("../../images/Avatar/Asset 9@3x.png"), name:'av9-1.png'},
    {src: require("../../images/Avatar/Asset 9.1@3x.png"), name: 'av9-2.png'},
    {src: require("../../images/Avatar/Asset 9.2@3x.png"), name: 'av9-3.png'},
  ],
  [
    {src: require("../../images/Avatar/Asset 10@3x.png"), name:'av10-1.png'},
    {src: require("../../images/Avatar/Asset 10.1@3x.png"), name: 'av10-2.png'},
    {src: require("../../images/Avatar/Asset 10.2@3x.png"), name: 'av10-3.png'},
  ],
  [
    {src: require("../../images/Avatar/Asset 11@3x.png"), name:'av11-1.png'},
    {src: require("../../images/Avatar/Asset 11.1@3x.png"), name: 'av11-2.png'},
    {src: require("../../images/Avatar/Asset 11.2@3x.png"), name: 'av11-3.png'},
  ],
  [
    {src: require("../../images/Avatar/Asset 12@3x.png"), name:'av12-1.png'},
    {src: require("../../images/Avatar/Asset 12.1@3x.png"), name: 'av12-2.png'},
    {src: require("../../images/Avatar/Asset 12.2@3x.png"), name: 'av12-3.png'},
  ],
  [
    {src: require("../../images/Avatar/Asset 13@3x.png"), name:'av13-1.png'},
    {src: require("../../images/Avatar/Asset 13.1@3x.png"), name: 'av13-2.png'},
    {src: require("../../images/Avatar/Asset 13.2@3x.png"), name: 'av13-3.png'},
  ],
  [
    {src: require("../../images/Avatar/Asset 14@3x.png"), name:'av14-1.png'},
    {src: require("../../images/Avatar/Asset 14.2@3x.png"), name: 'av14-2.png'},
  ],
  [
    {src: require("../../images/Avatar/Asset 15@3x.png"), name:'av15-1.png'},
    {src: require("../../images/Avatar/Asset 15.1@3x.png"), name: 'av15-2.png'},
    {src: require("../../images/Avatar/Asset 15.2@3x.png"), name: 'av15-3.png'},
  ],
  [
    {src: require("../../images/Avatar/Asset 16@3x.png"), name:'av16-1png'},
    {src: require("../../images/Avatar/Asset 16.1@3x.png"), name: 'av16-2.png'},
    {src: require("../../images/Avatar/Asset 16.2@3x.png"), name: 'av16-3.png'},
  ],
]



// WEBPACK FOOTER //
// ./src/components/StudentProfile/index.jsx